// extracted by mini-css-extract-plugin
export default {"container":"duration_container__13YDC"};